import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IRecordIdentifiersResponse, TIdentifierRecordType } from './types';

/**
 * The identifiers currently held against one record, grouped by instance.
 *
 * Only keys the addon still declares come back, so a key an addon has stopped declaring
 * never reaches the form.
 */
export const getRecordIdentifiers = async (
  recordType: TIdentifierRecordType,
  recordId: string,
): Promise<IRecordIdentifiersResponse> => {
  const url = `${API_URL}/extensions/records/${recordType}/${recordId}/identifiers`;
  try {
    const res = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
    if (!res.ok) throw new Error(res.statusText);
    return await res.json();
  } catch (e) {
    throw new Error('Could not fetch the integrations values', { cause: e });
  }
};
